var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoMedia01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745_2_",
    d: "M31,32.8L7.2,9C6.6,8.4,5.6,8.4,5,9s-0.6,1.6,0,2.2L28.8,35c0.6,0.6,1.6,0.6,2.2,0 C31.6,34.4,31.6,33.4,31,32.8L31,32.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748_1_",
    d: "M5,32.8L28.8,9c0.6-0.6,1.6-0.6,2.2,0c0.6,0.6,0.6,1.6,0,2.2L7.2,35c-0.6,0.6-1.6,0.6-2.2,0 C4.4,34.4,4.4,33.4,5,32.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    d: "M5.1,0.6h25.8c0.7,0.1,1.3,0.8,1.2,1.5c0.1,0.7-0.4,1.4-1.2,1.5H5.1C4.4,3.5,3.8,2.8,3.9,2.1 C3.8,1.4,4.4,0.7,5.1,0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoMedia01);
export default __webpack_public_path__ + "static/media/ico-funcao-media-01.4f0dbd5da24d1e5554dad9031a0d9389.svg";
export { ForwardRef as ReactComponent };